import { OwaDate, endOfDay, startOfDay, addDays } from 'owa-datetime';

/** Returns a Date Range that covers the entire day in which the provided date happens. */
export default function getFullDayFromDate(date: OwaDate, numDaysInDayRange: number) {
    return {
        start: startOfDay(date),
        end: endOfDay(addDays(date, numDaysInDayRange - 1)),
    };
}
